import React from 'react';
import PropTypes from 'prop-types';
import style from '../Debug.module.scss';

const ResetPanel = (props = {}) => {
  const { handleResetClick } = props;

  return (
    <div className={style.panel}>
      <div className={style.header}>Reset Settings</div>
      <div className={style.body}>
        <div className={style.formLabel}>This will reset all values set using the debug panel.</div>
        <button onClick={handleResetClick} type="button">
          Reset All Values
        </button>
      </div>
    </div>
  );
};

ResetPanel.propTypes = {
  handleResetClick: PropTypes.func.isRequired,
};

export default ResetPanel;
